import WhatsNewBanners from './WhatsNewBanners';

export default WhatsNewBanners;
